export const VALIDATION_MESSAGES = {
  ACCOUNT_NUMBER_REQUIRED: 'Account Number Column must be selected to proceed',
  ISIN_REQUIRED: 'ISIN Column must be selected to proceed',
  SYMBOL_REQUIRED: 'Symbol Column must be selected to proceed',
  DUPLICATE_SELECTION:
    'CRITICAL: Cannot use the same column for multiple fields',
  INVALID_COLUMN: 'CRITICAL: Selected column is no longer available',
};
